import { CultureInfo } from '../culture-info.model';
import { CultureInfoZhHant } from './zh-Hant';

/**
 * @ignore
 */
export const CultureInfoZhHantCN: CultureInfo = {
  name: 'zh-Hant-CN',
  displayName: '繁體中文（中國大陸）',
  iso3LanguageCode: 'zho',
  iso2LanguageCode: 'zh',
  ietfLanguageTag: 'zh-Hant-CN',
  parent: CultureInfoZhHant
};
